import { render } from "./ClassDiagramResults.vue?vue&type=template&id=7926524f&scoped=true&ts=true"
import script from "./ClassDiagramResults.vue?vue&type=script&lang=ts"
export * from "./ClassDiagramResults.vue?vue&type=script&lang=ts"

import "./ClassDiagramResults.vue?vue&type=style&index=0&id=7926524f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7926524f"]])

export default __exports__